<template>
  <section class="home">
    <div class="container">
      <div class="row">
        <div class="home__title-wrapper">
          <div class="major__title home__title">
            Калькулятор <br>
            клиновидной теплоизоляции
          </div>
        </div>
        <img src="@/assets/img/banner-mobile.jpg"
             class="home__banner-mobile"
             alt="banner"
             width="100%">
        <img src="@/assets/img/banner-tablet.jpg"
             class="home__banner-tablet"
             alt="banner"
             width="100%">
        <div class="col-12">
          <div class="home__banner">
            <img src="@/assets/img/logo.svg" class="home__banner-logo" alt="logo">
            <router-link to="/wizard/0" class="home__banner-btn" :class="{ disabled: true }"
                         onclick="dataLayer.push({'event': 'calc-wedge-insulating-step1'})">
              Начать расчет
              <img src="@/assets/img/arrow.svg" alt="→">
            </router-link>
          </div>
        </div>
        <div class="home__info">
          <div class="home__info-text">С помощью данного калькулятора Вы сможете рассчитать
            необходимое количество  теплоизоляции для формирования основного и контруклона на
            плоской кровле.</div>
          <div class="home__info-call">
            <div class="text">Есть вопросы?</div>
            <a href="tel:88006000565" class="link">8 800 600 0565</a>
          </div>
        </div>
        <div class="home__minorInfo">
          <div class="home__minorInfo-text">
            Онлайн калькулятор создан специалистами корпорации ТехноНИКОЛЬ. Все данные используемые
            в расчетах конкретных систем (кроме данных, которые нужно ввести вручную) выбираются
            согласно  ГОСТ, СП и ISO для каждой системы в отдельности.
          </div>
        </div>
      </div>
    </div>
    <Footer />
    <transition name="fading">
      <div class="ratio__modal-overlay" v-if="showModal" @click.self="cancel()">
        <div class="ratio__modal">
          <div class="text">
            Доступна новая версия Калькулятора клиновидной изоляции v2.0. Воспользоваться ею можно, перейдя по <a href="https://calc-wedges2.tn.ru/">ссылке</a>
          </div>
          <div class="ratio__modal-btns">
            <button class="btn cancel" @click="cancel()">ОК</button>
          </div>
        </div>
      </div>
    </transition>
  </section>
</template>

<script>

import { mapState } from 'vuex';
import Footer from '@/components/Footer.vue';

export default {
  data() {
    return {
      category: '',
      showModal: true
    };
  },
  components: {
    Footer,
  },
  methods: {
    cancel() {
      this.showModal = false
    }
  },
  async mounted() {
    if ((typeof (this.$route.query.category) !== 'undefined') && (this.$route.query.category !== '')) {
      if (!isNaN(this.$route.query.category)) {
        this.category = (parseInt(this.$route.query.category, 10));
        await this.$store.dispatch('fetchMaterialsMain', this.category);
      }
    } else if (typeof (this.$session.get('category')) !== 'undefined') {
      await this.$store.dispatch('fetchMaterialsMain', this.$session.get('category'));
    } else {
      await this.$store.dispatch('fetchMaterialsMain');
    }
    await this.$session.set('category', this.categoryFromState);
  },
  computed: {
    ...mapState({
      categoryFromState: state => state.category,
    }),
  },
};
</script>

<style lang="sass" scoped>
  .home
    color: $black
    text-align: left
    &__title
      grid-column-start: 2
      &-wrapper
        width: 100%
        display: grid
        +media((grid-template-columns: (320: 1fr 12fr 1fr, 768: 1fr 10fr 1fr)))
    &__banner
      box-sizing: border-box
      margin: 0 rem(-15)
      display: flex
      flex-direction: row
      align-items: flex-end
      justify-content: flex-end
      background-repeat: no-repeat
      background-position: center
      +media((border: (320: none, 768: rem(10) solid #ffffff)))
      +media((background-size: (768: cover, 960: cover)))
      +media((min-height: (320: unset, 768: rem(374))))
      +media((background-image: (320: none, 768: url('../assets/img/banner-tablet.jpg'),
      960: url('../assets/img/banner.jpg'))))
      +media((border-radius: (320: 0, 768: rem(4))))
      +media((padding: (320: 0, 768: 0 rem(87) rem(60) 0)))
      &-mobile
        +media((display: (576: none)))
      &-tablet
        +media((display: (320: none, 576: block, 768: none)))
      &-logo
        position: absolute
        +media((width: (320: rem(108), 400: auto)))
        +media((left: (320: rem(24), 768: rem(40))))
        +media((bottom: (320: rem(88), 768: rem(34))))
      // +media((display: (768: none)))
      &-btn
        cursor: pointer
        outline: none
        text-decoration: none
        background: $red
        display: flex
        flex-direction: row
        align-items: center
        color: #fff
        font-style: normal
        font-weight: bold
        font-size: rem(18)
        line-height: rem(22)
        padding: rem(22) rem(26)
        box-shadow: 0 rem(3) rem(7) rgba(0, 0, 0, 0.2)
        transition: .5s
        +media((width: (320: 100%, 768: auto)))
        +media((border-radius: (320: 0, 768: rem(4))))
        +media((justify-content: (320: space-between, 768: flex-start)))
        &.disabled
          background: #959595
          pointer-events: none
        img
          padding-left: rem(24)
        &:hover
          background: $red-hover-new
          box-shadow: 0 rem(5) rem(20) $black, 0 rem(3) rem(7) rgba(0, 0, 0, 0.2)
    &__info
      display: grid
      +media((padding: (320: rem(32) 0, 768: rem(51) 0)))
      border-bottom: rem(1) solid #D6D6D6
      +media((grid-template-columns: (320: 1fr 12fr 1fr, 768: 1fr 7fr 1fr 3fr)))
      &-text
        grid-column-start: 2
        font-style: normal
        font-weight: 500
        +media((font-size: (320: rem(14), 768: rem(18))))
        +media((line-height: (320: rem(24), 768: rem(32))))
        +media((padding-bottom: (320: rem(32), 768: 0)))
      &-call
        grid-column-start: 4
        +media((grid-column-start: (320: 2, 768: 4)))
        font-style: normal
        font-weight: bold
        font-size: rem(18)
        line-height: rem(22)
        .text
          padding-bottom: rem(12)
        .link
          color: $red
          transition: .5s
          text-decoration: none
          padding-bottom: rem(4)
          border-bottom: rem(1) dashed rgba(227, 7, 19, 0.4)
          &:hover
            color: $red-hover
    &__minorInfo
      display: grid
      +media((padding: (320: rem(32) 0, 768: rem(51) 0)))
      +media((grid-template-columns: (320: 1fr 12fr 1fr, 768: 1fr 10fr 1fr)))
      &-text
        grid-column-start: 2
        font-style: normal
        font-weight: 500
        font-size: rem(12)
        line-height: rem(22)
  .ratio
    &__modal-btns
      display: flex;
      justify-content: center;
    &__modal .text
      text-align: center
</style>
